import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ErrorBoundary } from './components/ErrorBoundary';
import { logger } from './lib/logger';
import { initSentry } from './lib/sentry';

// Initialize Sentry globally for client-side exception and performance telemetry
initSentry();

// Register Service Worker for PWA installability and offline support
if ('serviceWorker' in navigator && typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registered successfully with scope:', registration.scope);
      })
      .catch((error) => {
        console.warn('[PWA] Service Worker registration failed:', error);
      });
  });
}

// Global error listener for non-React errors
window.onerror = function(message, source, lineno, colno, error) {
  logger.critical('FATAL_WINDOW', String(message), { source, lineno, error: error?.stack });
  
  const root = document.getElementById('root');
  if (root && (root.innerHTML === '' || root.innerHTML.includes('Loading'))) {
    root.innerHTML = `
      <div style="padding: 40px; color: #e11d48; font-family: system-ui, sans-serif; max-width: 600px; margin: 0 auto;">
        <h1 style="font-weight: 900; letter-spacing: -0.05em;">Fatal Startup Error</h1>
        <p style="color: #4b5563;">The application failed to initialize. We have logged this error.</p>
        <div style="background: #f8fafc; padding: 20px; border-radius: 12px; border: 1px solid #e2e8f0; margin-top: 20px;">
          <code style="font-size: 12px; color: #ef4444; word-break: break-all;">${message}</code>
        </div>
        <button onclick="window.location.reload()" style="margin-top: 20px; background: #2563eb; color: white; border: none; padding: 12px 24px; border-radius: 8px; font-weight: bold; cursor: pointer;">Reload Page</button>
      </div>
    `;
  }
};

// Handle unhandled promise rejections (silent API failures)
window.onunhandledrejection = function(event) {
  logger.error('UNHANDLED_PROMISE', event.reason?.message || 'Unknown promise failure', { reason: event.reason });
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('[Main] Root element not found!');
} else {
  console.log('[Main] Rendering to root...');
  createRoot(rootElement).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
}
